import React, { useRef, useState, useCallback } from "react";
import imagineHomeService from "./imagineHomeService";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";

const ListFiles = ({ data = {}, list, upload, quoteClicked, forQuote = false, splitChar }) => {
    const downloadUrlMap = useRef({});
    const serviceId = localStorage.getItem("serviceId");
    const isProposalUpload = list === "designer" ? true : false;

    const handledown_preview = async (e) => {
        const fileKey = e.currentTarget.id;
        let downloadurl = "";
        if (fileKey) {
            if (!(fileKey in downloadUrlMap.current)) {
                const formData = new FormData();
                formData.append("serviceId", serviceId);
                formData.append("fileKey", fileKey);

                const downloadURLRES = await imagineHomeService.fetchDownloadFileUrl(formData);
                downloadurl = downloadURLRES?.download_url ?? "";
            } else downloadurl = downloadUrlMap.current[fileKey];

            window.open(downloadurl, "_blank");
        }
    };
    const getStatus = (status) => {
        switch (status) {
            case "Accepted":
                return "Approvals";
            case "Rejected":
                return "Approvals";
            case "PartiallyAccepted":
                return "Approvals";
            default:
                return "Pending Approvals";
        }
    };
    return (
        <>
            <div>
                {Object.keys(data).map((item) => {
                    return (
                        <React.Fragment key={item}>
                            <div key={item} className="designer-card-border p-4 mt-3 ">
                                <div className={isProposalUpload && "flex align-items-center mb-4"} style={{ gap: 10 }}>
                                    <p className="font-larken text-lg m-0">{forQuote ? "Proposal" : item?.split(splitChar) ? item.split(splitChar)[1] : "--"}</p>
                                    {isProposalUpload && (
                                        <div>
                                            <Button
                                                label="UPLOAD"
                                                id={item}
                                                onClick={(e) => upload(e, forQuote)}
                                                icon="pi pi-file"
                                                className="p-button-rounded p-button-info text-xs py-2 font-Gerstner-ProgramRegular font-semibold px-4 charcoal-color"
                                                style={{
                                                    letterSpacing: "1.2px",
                                                    backgroundColor: "#9AAB89 ",
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>

                                {!isProposalUpload && <Divider className="m-0 mt-1 mb-3" style={{ backgroundColor: "#9AAB89", height: "1px" }} />}
                                <div className="overflow-x-auto">
                                    {Object.keys(data[item]).map((itemObj, ind) => (
                                        <React.Fragment key={itemObj}>
                                            {data[item][itemObj].map((file, i) => (
                                                <React.Fragment key={file.filekey || i}>
                                                    <div
                                                        className="charcoal my-2 flex col-12 p-0 align-items-center"
                                                        style={{
                                                            letterSpacing: "1.44px",
                                                            gap: 15,
                                                            minWidth: "800px",
                                                        }}
                                                    >
                                                        {!forQuote && (
                                                            <p className="m-0 p-0" style={{ minWidth: "80px" }}>
                                                                {i === 0 ? itemObj : ""}
                                                            </p>
                                                        )}

                                                        <p className="m-0 p-0 flex-1" style={{ minWidth: "250px" }}>
                                                            {file.filename ? (
                                                                <>
                                                                    <i className="pi pi-file mr-2"></i>
                                                                    {file.filename}
                                                                </>
                                                            ) : (
                                                                <span className="text-grey-700" style={{ color: "#1D1B1C" }}>
                                                                    {forQuote ? "No proposal found" : itemObj ? "--" : "No files found for this room"}
                                                                </span>
                                                            )}
                                                        </p>

                                                        <p className="m-0 p-0" style={{ minWidth: "120px" }}>
                                                            {!forQuote && file.filename ? file.roomType : ""}
                                                        </p>

                                                        {file.filename && file.filekey && <i id={file.filekey} style={{ color: "#5295E2", minWidth: "100px" }} className="pi pi-cloud-download text-3xl cursor-pointer" onClick={(e) => handledown_preview(e)} />}

                                                        {isProposalUpload && file.isQuote && file.details ? (
                                                            <Button
                                                                label={file?.details?.status ? getStatus(file.details.status) : ""}
                                                                className="p-button-rounded p-button-outlined p-button-sm font-Gerstner-ProgramRegular"
                                                                style={{
                                                                    minWidth: "160px",
                                                                    padding: "0.25rem 0.75rem",
                                                                    width: "auto",
                                                                    letterSpacing: "1.2px",
                                                                    color: getStatus(file?.details?.status) === "Pending Approvals" ? "#BFAD5B" : "#9AAB89",
                                                                    borderColor: "#9AAB89",
                                                                    visibility: file.isQuote && file.details ? "visible" : "hidden",
                                                                }}
                                                                onClick={(e) => {
                                                                    e.target.blur();
                                                                    const data = {
                                                                        ...file.details,
                                                                        body: file.details.docDetails,
                                                                    };
                                                                    delete data.docDetails;
                                                                    quoteClicked(data);
                                                                }}
                                                            />
                                                        ) : (
                                                            <div
                                                                style={{
                                                                    minWidth: "160px",
                                                                }}
                                                            ></div>
                                                        )}
                                                    </div>

                                                    {i === data[item][itemObj].length - 1 && ind !== Object.keys(data[item]).length - 1 && <Divider className="m-0 my-3" style={{ backgroundColor: "#BFAD5B", height: "1px" }} />}
                                                </React.Fragment>
                                            ))}
                                        </React.Fragment>
                                    ))}
                                </div>
                                {isProposalUpload && (data[item]?.length > 1 || (data[item]?.length === 1 && data[item][0].filename !== "")) ? <div className="flex mt-4 justify-content-between" style={{ gap: 15 }}></div> : null}
                            </div>
                        </React.Fragment>
                    );
                })}
            </div>
        </>
    );
};

export default ListFiles;
